import { IFileAgGrid, IFolderAgGrid, IValueLabel } from "@mctypes/global.types";
import React from "react";
import { Flex } from "@mantine/core";
import HSpace from "../HSpace";
import FileTableAgGrid from "./FileTableAgGrid";
import FolderSelector from "./FolderSelector";

const FolderAndFileSelector: React.FC<{
  folders: IFolderAgGrid[];
  files: IFileAgGrid[];
  goBack: () => void;
  currentFolder?: IFolderAgGrid;
  getSelectedFilesCb: (files: IFileAgGrid[]) => void;
  onSelectActiveFolder: (folder: IFolderAgGrid) => void;
  onGoToNextFolder: (folder: IFolderAgGrid) => void;
  filterExtension?: IValueLabel;
  highlightedFolder?: IFolderAgGrid;
  canGoBack: boolean;
  foldersLoading?: boolean;
  filesLoading?: boolean;
}> = ({
  folders,
  files,
  goBack,
  currentFolder,
  getSelectedFilesCb,
  onSelectActiveFolder,
  onGoToNextFolder,
  filterExtension,
  highlightedFolder,
  canGoBack,
  foldersLoading,
  filesLoading,
}) => {
  return (
    <Flex h="100%" style={{ overflow: "auto" }} w="100%">
      <FolderSelector
        currentFolder={currentFolder}
        folders={folders}
        onSelectActiveFolder={onSelectActiveFolder}
        onGoToNextFolder={onGoToNextFolder}
        highlightedFolder={highlightedFolder}
        goBack={goBack}
        canGoBack={canGoBack}
        isLoading={foldersLoading}
      />
      <HSpace />
      <FileTableAgGrid
        files={files}
        getSelectedFilesCb={getSelectedFilesCb}
        filterExtension={filterExtension}
        isLoading={filesLoading}
      />
    </Flex>
  );
};

export default FolderAndFileSelector;
